import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'lib-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MessageComponent {
  @Input() messages: string[] = [];
}
